import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Station from './Station';
import strings from '../utility/strings.js';

const Meal = (props) => {
  const { favorites, status, stations, name, params, dateFull, currentUser, loadingMenu, GET_USER, highlightString, showOnlyString, hiddenString } = props;
  let stationsElement = null;

  if (loadingMenu) {
    // Menu is still loading from GraphQL
    let array = [1, 2, 3];
    let loadingSkeleton = array.map((x) => {
      return <div className="station" key={x}>
        <div className="station-container">
          <div className="station-name">
            <Skeleton width="50%" height={50} style={{ margin: '0 auto' }} />
          </div>
          <div className="station-items">
            <Skeleton width="50%" height={50} />
            <Skeleton width="70%" height={50} />
            <Skeleton width="30%" height={50} />
            <Skeleton width="60%" height={50} />
          </div>
        </div>
      </div>
    });

    return <div className="meal">
      {loadingSkeleton}
    </div>

  } else {
    //Meal loading
    if (!status && !stations) {
      return <div className="meal meal--none" key={"none_" + Math.floor(Math.random() * 9)}>
        <div className="meal-status">
          <span className="meal-status-header">{strings.loadingexclamation}</span>
          <div className="spinner">
            <div className="double-bounce1"></div>
            <div className="double-bounce2"></div>
          </div>
          <span className="meal-status-message">{strings.loadingmessage}</span>
        </div>
      </div>;
    }
    //Meal Closed
    if (status.toLowerCase() === "closed") {
      return <div className="meal meal--closed">
        <div className="meal-status">
          <span className="meal-status-message">{strings.closemessage} {name}</span>
        </div>
      </div>;
    }
    //Meals Hidden
    if (status.toLowerCase() === "hidden") {
      return <div className="meal meal--closed" key={"none_" + Math.floor(Math.random() * 9)}>
        <div className="meal-status">
          <span className="meal-status-message">{strings.nomeals}</span>
        </div>
      </div>;
    }
    //Meal Unavailable
    if (status.toLowerCase() === "unavailable") {
      return <div className="meal meal--problem" key={"none_" + Math.floor(Math.random() * 9)}>
        <div className="meal-status">
          <span className="meal-status-header">{strings.problemexlamation}</span>
          <span className="meal-status-message">{strings.problemmessage}</span>
        </div>
      </div>;
    }

    let stationProps = {
      params: params,
      mealName: name,
      dateFull: dateFull,
      currentUser: currentUser,
      GET_USER: GET_USER,
      highlightString: highlightString,
      showOnlyString: showOnlyString,
      hiddenString: hiddenString
    };
    stationsElement = stations.map(function (station) {
      return <Station favorites={favorites} key={station.name + "_Station"}  {...station} {...stationProps} />;
    });


    // Not sure what the purpose of the fillers was, may be deprecated code from an earlier feature. Commenting out for now.
    return <div className="meal">
      {stationsElement}
      {/* {fillers} */}
    </div>
  }
}

export default Meal;